import styled from "styled-components";

export const CmpCarManagementInfoContent = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto 70px;
`;

export const CmpCarInfoConentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 15px;
  margin-bottom: 50px;
`;

export const CmpCarInfoQuest = styled.div`
  width: 100%;

  span {
    color: ${(props) => [props.theme.colors.primary]};
    font-weight: 700;
  }
  font-size: 1.2rem;
  font-weight: 400;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
`;

export const CmpCarInfoItem = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 900;
  font-size: 14px;

  .small {
    width: 20%;
    color: rgba(135, 135, 135, 1);
    font-size: 12px;
    font-weight: 500;
  }
`;

export const CmpCarCheckDetail = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  margin-bottom: 130px;
`;

export const CmpButtonBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  bottom: 0;

  .small {
    width: 60%;
  }
`;
